export class Validators {
    static getElement(element) {
        if (typeof element == "string") {
            return window.document.getElementsByName(element)[0];
        }
        return element;
    }
    static regexp(element, expression) {
        element = Validators.getElement(element);
        let value = element.value;
        return new RegExp(expression).test(value);
    }
    static required(element) {
        return Validators.regexp(element, "^.+$");
    }
    static numbers(element) {
        return Validators.regexp(element, "^[0-9]*$");
    }
    static email(element) {
        return Validators.regexp(element, "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$");
    }
    static min(element, length) {
        return Validators.regexp(element, "^{" + length + ",}$");
    }
    static max(element, length) {
        return Validators.regexp(element, "^.{0," + length + "}$");
    }
    static checked(element) {
        return Validators.getElement(element).checked;
    }
    static selected(element) {
        return Validators.getElement(element).selectedIndex >= 0;
    }
    static compare(element, element2) {
        let e1 = Validators.getElement(element);
        let e2 = Validators.getElement(element2);
        if (e1 == null || e2 == null) {
            return false;
        }
        return e1.value == e2.value;
    }
}
/*
interface IValidator{
    element: HTMLInputElement | HTMLSelectElement;
    validate(): boolean;
}

export class RegExpValidator implements IValidator {
    public element: HTMLInputElement;
    public expression: string;

    constructor(element: HTMLInputElement, expression: string){
        this.element = element;
        this.expression = expression;
    }

    public validate(): boolean{
        return new RegExp(this.expression).test(this.element.value);
    }
}

export class RequiredValidator extends RegExpValidator {
   
    constructor(element: HTMLInputElement){
        super(element, "[\w\d]+");
    }

    public validate(): boolean{
        return super.validate();
    }
}

export class NumberValidator extends RegExpValidator {
   
    constructor(element: HTMLInputElement){
        super(element, "[0-9]");
    }

    public validate(): boolean{
        return super.validate();
    }
}

export class EmailValidator extends RegExpValidator {
   
    constructor(element: HTMLInputElement){
        super(element, "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$");
    }

    public validate(): boolean{
        return super.validate();
    }
}

export class CheckedValidator implements IValidator {
    public element: HTMLInputElement;

    constructor(element: HTMLInputElement){
        this.element = element;
    }

    public validate(): boolean{
        return this.element.checked;
    }
}

export class SelectedValidator implements IValidator {
    public element: HTMLSelectElement;

    constructor(element: HTMLSelectElement){
        this.element = element;
    }

    public validate(): boolean{
        return this.element.selectedIndex >= 0;
    }
}

export class MinLengthValidator extends RegExpValidator {
   
    constructor(element: HTMLInputElement, length: Number = 0){
        super(element, "^{" + length + ",}$");
    }

    public validate(): boolean{
        return super.validate();
    }
}

export class MaxLengthValidator extends RegExpValidator {
   
    constructor(element: HTMLInputElement, length: Number = 0){
        super(element, "^.{0," + length + "}$");
    }

    public validate(): boolean{
        return super.validate();
    }
}
*/ 
